import * as React from 'react';
import BingPixel from '../BingPixel';
import FacebookPixel from '../FacebookPixel';
import HotjarPixel from '../HotjarPixel';
import NextdoorPixel from '../NextdoorPixel';
import RedditPixel from '../RedditPixel';
import TiktokPixel from '../TiktokPixel';
import YelpPixel from '../YelpPixel';
import YellowAIChatbot from '../YellowAIChatbot';
import ConvertABScript from '../ConvertABScript';

type PostBodyComponentProps = {
    isBookingPage: boolean;
    isCMS: boolean;
};

export default function PostBodyComponents({
    isBookingPage,
    isCMS,
}: PostBodyComponentProps) {
    React.useEffect(() => {
        document.documentElement.classList.toggle('hide-bot', isBookingPage);
    }, [isBookingPage]);

    return (
        <>
            <YellowAIChatbot isCMS={isCMS} />
            <ConvertABScript />
            <BingPixel />
            <FacebookPixel />
            <HotjarPixel />
            <NextdoorPixel />
            <RedditPixel />
            <TiktokPixel />
            <YelpPixel />
        </>
    );
}
